export default __webpack_public_path__ + "static/media/Graphics_Fodler2-min.c5efce80.jpg";